var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53564 10C4.88819 7.05682 7.97714 5 11.5714 5C15.1656 5 18.2545 7.05682 19.6071 10C18.2545 12.9432 15.1656 15 11.5714 15C7.97714 15 4.88819 12.9432 3.53564 10ZM15.1428 10C15.1428 11.8409 13.5438 13.3333 11.5714 13.3333C9.59891 13.3333 7.99993 11.8409 7.99993 10C7.99993 8.15905 9.59891 6.66667 11.5714 6.66667C12.1418 6.66667 12.681 6.79149 13.1594 7.01348C12.7365 7.31828 12.4642 7.79613 12.4642 8.33333C12.4642 9.25383 13.2637 10 14.2499 10C14.5721 10 14.8743 9.92042 15.1352 9.78108C15.1402 9.8535 15.1428 9.92642 15.1428 10Z",
    fill: "#B6B6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3571 10.0002C13.3571 10.9207 12.5576 11.6668 11.5714 11.6668C10.5851 11.6668 9.78564 10.9207 9.78564 10.0002C9.78564 9.07966 10.5851 8.3335 11.5714 8.3335C12.5576 8.3335 13.3571 9.07966 13.3571 10.0002Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.20da790a44a82e88f9532349b6f3554c.svg";
export { ForwardRef as ReactComponent };